// data/properties.js
export const properties = [
  {
    id: "salkara-inn-main",
    name: "Salkara Inn (Kanjikode)",
    tagline: "Premium Suite Stay",
    address: "Toll Plaza, Palakkad - Coimbatore Rd, near Attappallam, Pudussery East, Kerala 678621",
    mapLink: "https://maps.app.goo.gl/iKELe6t5mDnUAFTU8?g_st=awb",
    contacts: ["9087700091", "9886666844"],
    heroImage: "/assets/2.png",
    gallery: ["/assets/suite.jpg", "/assets/kanj1.jpg", "/assets/kanj2.jpg", "/assets/kanj3.jpg"],
    notes: "OJAS SPA – Kerala Traditional Massage & Panchakarma Ayurveda Therapy",
    roomTiers: [
      {
        id: "main-suite", type: "Suite Room", count: 4, price: "₹ 3,000", priceUnit: "/ night",
        amenities: ["Air Conditioning", "Dental Kit", "Soap", "Shampoo", "Towel", "Television", "Sofa Set"]
      },
      {
        id: "main-ac", type: "AC Room", count: 5, price: "₹ 2,000", priceUnit: "/ night",
        amenities: ["Air Conditioning", "Soap", "Towel"], note: "No sofa set"
      },
      {
        id: "main-non-ac", type: "Non-AC Room", count: 3, price: "₹ 1,500", priceUnit: "/ night",
        amenities: ["Soap", "Towel"], note: "No kit, no TV"
      },
    ],
  },

  {
    id: "salkara-mini-walayar",
    name: "Salkara Mini (Walayar)",
    tagline: "Affordable Comfort",
    address: "Walayar Parking, Palakkad Main Road, Coimbatore 641105",
    mapLink: "https://maps.app.goo.gl/fv2XTK9iqumoe8xF6?g_st=awb",
    contacts: ["8428438445", "9886666844"],
    heroImage: "/assets/4.png",
    gallery: ["/assets/mini1.jpg", "/assets/mini2.jpg", "/assets/mini3.jpg", "/assets/mini4.jpg"],
    roomTiers: [
      { id: "mini-ac", type: "AC Room", count: 6, price: "₹ 1,800", priceUnit: "/ night" },
      { id: "mini-non-ac", type: "Non-AC Room", count: 4, price: "₹ 1,300", priceUnit: "/ night" },
    ],
  },

  {
    id: "salkara-inn-madukkarai",
    name: "Salkara Inn (Madukkarai)",
    tagline: "Executive Comfort",
    address: "Chettipalayam Pirivu, Madukkarai, Coimbatore, Tamil Nadu 641105",
    mapLink: "https://maps.app.goo.gl/gVSeZzRzFeULN3cV6?g_st=awb",
    contacts: ["9087700093", "9886666844"],
    heroImage: "/assets/3.png",
    gallery: ["/assets/mad1.jpg", "/assets/mad2.jpg", "/assets/mad3.jpg", "/assets/mad4.jpg"],
    notes: "Extra beds optional, double cot, 3 adults max, coffee & food available with payment.",
    roomTiers: [
      {
        id: "mad-executive", type: "Executive Room", count: 2, price: "₹ 2,500", priceUnit: "/ night",
        roomSize: "260 Sq Ft", amenities: ["Air Conditioning", "Mini Fridge", "Sofa Set", "Dining Table", "Soap", "Towel"]
      },
      {
        id: "mad-deluxe", type: "Deluxe Room", count: 2, price: "₹ 2,500", priceUnit: "/ night",
        roomSize: "230 Sq Ft", amenities: ["Air Conditioning", "Mini Fridge", "Sofa Set", "Dining Table", "Soap", "Towel"]
      },
      {
        id: "mad-ac", type: "AC Room", count: 8, price: "₹ 2,000", priceUnit: "/ night",
        amenities: ["Air Conditioning"]
      },
      {
        id: "mad-non-ac", type: "Non-AC Room", count: 7, price: "₹ 1,500", priceUnit: "/ night",
        amenities: ["RO Water"], note: "No TV"
      },
    ],
  },

  {
    id: "salkara-nest",
    name: "Salkara Nest (Chettipalayam Pirivu)",
    tagline: "Budget Friendly Stay",
    address: "Chettipalayam Piruvu, Marapalam, Madukkarai Market Road, Coimbatore 641105",
    mapLink: "https://maps.app.goo.gl/H8riMHnHf3fYWfds7?g_st=awb",
    contacts: ["9087700092", "9886666844"],
    heroImage: "/assets/1.png",
    gallery: ["/assets/nest1.jpg", "/assets/nest2.jpg", "/assets/nest3.jpg", "/assets/nest4.jpg"],
    roomTiers: [
      { id: "nest-ac", type: "AC Room", count: 6, price: "₹ 1,800", priceUnit: "/ night" },
      { id: "nest-non-ac", type: "Non-AC Room", count: 4, price: "₹ 1,300", priceUnit: "/ night" },
      {
        id: "nest-dorm", type: "Dormitory", count: 4, price: "₹ 500", priceUnit: "/ person",
        note: "Common bathroom, no TV"
      },
    ],
  }
];

export const universalAmenities = ["Free Wi-Fi", "Hot Water", "Soap", "Towel"];

export const bookingPolicy = {
  familyOccupancy: "2 Adults + 2 Kids",
  extraBed: "Available on request",
  roomService: "24 x 7",
};

export const getPropertyById = (id) => properties.find((p) => p.id === id);